
<script>

    import { mapState,mapActions } from 'vuex';
    import { closestSelector } from '../../../commonjs/helpers';

    export default {
        data () {
            return {
                sectionNode: null, //parent section of the enclosed component
                sectionId: "", //parent section id
                componentNode: null,
                componentId: "",
                megamenuWrapper : null,
                megamenuWrapperId : "",
                megamenuComponentWrapperId : "",
                nestedComponentIds: [], // array with the ids of all the dynamic components that exist inside the component
                nestedElementIds: [],// array with the ids of all the elements that exist inside the component
                myIdName: "componentId",
                renderInProgress : false,
                renderQueue: {},
            }
        },
        props: {
            registrationData: {
                type: Object,
                required: true
            }
        },
        computed: {
            ...mapState('components',[
                'componentsData',
            ]),
            ...mapState([
                'serverImg',
                'isMobile'
            ]),
            componentData () {
                let dataToReturn = {};

                if (this.hasContext("school-topbar")) {
                    dataToReturn =  this.schoolTopbarData &&
                    this.schoolTopbarData[this.topbarStatus] &&
                    this.schoolTopbarData[this.topbarStatus].components &&
                    this.schoolTopbarData[this.topbarStatus].components[this.componentId] ?
                    this.schoolTopbarData[this.topbarStatus].components[this.componentId] : {};
                } else if (this.hasContext("page-topbar")) {
                    dataToReturn =  this.pageTopbarData &&
                    this.pageTopbarData[this.topbarStatus] &&
                    this.pageTopbarData[this.topbarStatus].components &&
                    this.pageTopbarData[this.topbarStatus].components[this.componentId] ?
                    this.pageTopbarData[this.topbarStatus].components[this.componentId] : {};
                } else if (this.hasContext("schoolFooter")) {
                    dataToReturn =  this.schoolFooterData &&
                    this.schoolFooterData[this.footerStatus] &&
                    this.schoolFooterData[this.footerStatus].components &&
                    this.schoolFooterData[this.footerStatus].components[this.componentId] ?
                    this.schoolFooterData[this.footerStatus].components[this.componentId] : {};

                } else if (this.hasContext("pageFooter")) {
                    dataToReturn =  this.pageFooterData &&
                    this.pageFooterData[this.footerStatus] &&
                    this.pageFooterData[this.footerStatus].components &&
                    this.pageFooterData[this.footerStatus].components[this.componentId] ?
                    this.pageFooterData[this.footerStatus].components[this.componentId] : {};

                } else {
                    dataToReturn = this.componentsData && this.componentsData[this.componentId] ? this.componentsData[this.componentId] : {} // this.getDefaultDataStructure;
                }

                return dataToReturn;

            },
            myNode () {
                return this.componentNode;
            },
            myState () {
                return this.componentStates[this.componentId] ? this.componentStates[this.componentId] : {};
            },
            myNodeType () {
                return this.componentType;
            },
            myData () {
                return this.componentData;
            },
            myId () {
                return this.componentId;
            },
            getDefaultDataStructure () {
                //usually overridden
                return {
                    componentType: this.componentType,
                    componentId: this.componentId,
                    styles: null,
                    itemVisibilitySettings: null
                }
            }
        },
        created () {
            this.componentCreated();
        },
        mounted () {
            if (this.rendersWithVue) {
                this.componentNode.innerHTML = "";
                this.componentNode.append(this.$el);
            }
        },
        methods: {
            ...mapActions('components',[
                'setComponentData',
                'addComponentState',
                'editRegisteredComponent',
                'addNewComponent',
            ]),
            renderingCompleted (renderData) {
                this.renderInProgress = false;
            },
            componentCreated () {
                this.handleRegistration().then( () => {
                    // this.findMyNode();
                    this.findMySection();
                    this.findMyMegamenuWrapper();
                    this.setTopbarStatus();
                    this.setFooterStatus();
                    this.addComponentState({state: this});

                    //get component data from the data that is saved otherwise if that doesnt exist get the default data structure


                    this.$nextTick( () => {
                        let parent = this.getParent();

                        // let bindingFinishPromise = new Promise()
                        if (parent) {
                            this.bindComponentToParent(parent, this);
                        }
                    })
                })
            },
            componentContextBindingFinished () {},
            acquireComponentData () {
                if (typeof this.myData.componentId === "undefined") {
                    this.changeMyData(copyJson(this.getDefaultDataStructure));
                } else if (!Object.keys(this.getDefaultDataStructure).every(key => typeof this.myData[key] !== "undefined") ) {

                    let updatedValues = {};

                    Object.keys(this.getDefaultDataStructure).forEach( key => {
                        let defaultValue = this.getDefaultDataStructure[key];
                        if (typeof this.myData[key] === "undefined") {
                            updatedValues[key] = defaultValue;
                        }
                    })

                    this.changeMyData(updatedValues);
                }
            },
            componentCreationCallback () {

            },
            findMyNode () {
                this.componentNode = document.querySelector("#" + this.componentId);
            },
            findMySection () {
                this.sectionNode = closestSelector(this.componentNode,"." + this.classSelectors.sectionNode);
                this.sectionId = this.sectionNode ? this.sectionNode.getAttribute("id") : "";
            },
            emitToSection (event,eventData) {

                if (!eventData) { //generally just sending the component id
                    eventData = {
                        id: this.componentId
                    }
                }

                if (this.sectionStates[this.sectionId]) {
                    this.sectionStates[this.sectionId].$emit(event,eventData);
                }
            },
            handleSliderCreation (renderData) {
                if (this.isMobile) {
                    return;
                }

                if (renderData.showSlider && renderData.cardsPerRow * renderData.rows <= renderData.amountOfCards) { //make sure we can have a 2nd page in order to render slider
                    this.destroySlider();
                    this.createSlider();
                } else if (!renderData.showSlider) {
                    this.destroySlider();
                }

            },
            changeMyData (newData) {
                // console.log("change applied in component: " , this.myId , newData);
                if (!newData.componentId) {
                    newData.componentId = this.componentId;
                }

                this.setComponentData(newData);
            },
            createComponentId () {
                return "component_" + window.createTimeID();
            },
            createMyId () {
                return this.createComponentId();
            },
            handleRegistration () {
                //tempId is used either when parsing DOM and finding an element without an ID or when inserting a new element from the elements list

                if (this.registrationData.tempId) {
                    return this.handleRegistrationWithTempId();
                } else if (this.registrationData.componentId) {
                    return this.handleRegistrationWithExistingId();
                }
            },
            handleRegistrationWithTempId () {

                let newComponentId = this.createComponentId();

                this.editRegisteredComponent({
                    action: "replaceTempId",
                    tempId: this.registrationData.tempId,
                    componentId: newComponentId
                });


                //when a section is found as a node without an id
                if (this.registrationData.componentNode && !this.registrationData.newElement) {

                    return new Promise( (resolve,reject) => {
                        this.componentNode = this.registrationData.componentNode;
                        this.componentNode.setAttribute("id",newComponentId);
                        this.componentId = newComponentId;
                        resolve();
                    })

                } else if (this.registrationData.componentNode && this.registrationData.newElement) {
                    return new Promise( (resolve,reject) => {

                        if (this.nodeStateToInsertAfter) {
                            this.nodeStateToInsertAfter.insertNode(this.registrationData.componentNode,'afterend',true);
                        } else if (this.nodeStateToAppendIn) {
                            this.nodeStateToAppendIn.appendChildNode(this.registrationData.componentNode);
                        }

                        this.componentNode = this.registrationData.componentNode;
                        this.componentNode.setAttribute("id",newComponentId);
                        this.componentId = newComponentId;
                        resolve();
                    })
                }  else if (this.registrationData.liquidFile){ //when we have no node but a reference to a liquid file to render

                    return this.acquireSectionTemplate(this.registrationData.liquidFile).then( elementHtml => {
                        let dummyWrapper = document.createElement("div");
                        dummyWrapper.innerHTML = elementHtml.trim();
                        let newComponentNode = dummyWrapper.firstChild;
                        newComponentNode.id = newComponentId;

                        this.componentNode = newComponentNode;
                        this.componentId = newComponentId;
                    })
                }
            },
            handleRegistrationWithExistingId () {
                return new Promise( (resolve,reject) => {
                    this.componentNode = this.registrationData.componentNode;
                    this.componentId = this.componentNode.getAttribute("id");
                    resolve();
                })
            },
            renderComponent () {
                // override in components
            },
            debouncedRenderComponent () {
                // this function solved the problem of multiple renders of the same component by creating multiple debounced renderComponent functions
                // it creates a different timeout for every component so when we have multiple components in the same page, their rendering functions
                // don't conflict

                const wait = 10; // timeout timer in ms

                clearTimeout(this.renderQueue[this.myId]);

                this.renderQueue[this.myId] = setTimeout(() => {
                    //console.log('***** Deb Rendering Component: ', this.componentId, this.componentType, this.renderQueue);
                    this.renderComponent();
                }, wait);
            }
        },
    }
</script>
